
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M28 16a2.181 2.181 0 00-2.181-2.182h-1.377a8.693 8.693 0 00-.93-2.245l.974-.973A2.181 2.181 0 1021.4 7.515l-.974.973a8.693 8.693 0 00-2.245-.93V6.183a2.182 2.182 0 00-4.364 0v1.377a8.692 8.692 0 00-2.245.93l-.973-.974A2.181 2.181 0 107.515 10.6l.973.973a8.692 8.692 0 00-.93 2.245H6.183a2.182 2.182 0 000 4.364h1.377c.206.799.52 1.552.93 2.245l-.974.974a2.181 2.181 0 103.085 3.085l.973-.974c.693.41 1.447.724 2.245.93v1.377a2.182 2.182 0 004.364 0v-1.377a8.694 8.694 0 002.245-.93l.974.974a2.181 2.181 0 103.085-3.085l-.974-.974c.41-.692.724-1.446.93-2.245h1.377A2.182 2.182 0 0028 16z","stroke":"#121131","stroke-width":"2","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M16 19.273a3.273 3.273 0 100-6.545 3.273 3.273 0 000 6.545z","stroke":"#121131","stroke-width":"2","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    